var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"], ["\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"])));
var ItemsWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n"], ["\n  position: relative;\n  overflow: hidden;\n"])));
var Item = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var IndexContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  text-align: right;\n  color: #000;\n"], ["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  text-align: right;\n  color: #000;\n"])), function (props) { return "" + px2rem(props.top); }, px2rem(50), px2rem(100), px2rem(50), px2rem(36));
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.autoMove = function () {
            var _a = _this.props, isVertical = _a.isVertical, speed = _a.speed;
            var _b = _this.state, currentIndex = _b.currentIndex, translate = _b.translate, containerHeight = _b.containerHeight, containerWidth = _b.containerWidth;
            var diffIndex = currentIndex + 1;
            var diffTranslate = translate - (isVertical ? containerHeight : containerWidth);
            if (diffIndex >= _this.validChildren.length) {
                diffIndex = 0;
                diffTranslate = 0;
            }
            _this.setState({
                animating: true,
                currentIndex: diffIndex,
                translate: diffTranslate,
            }, function () {
                setTimeout(function () { return _this.setState({ animating: false }); }, speed);
                _this.props.afterChange && _this.props.afterChange(_this.state.currentIndex);
            });
        };
        _this.handleTouchStart = function (e) {
            var _a = _this.state, touching = _a.touching, translate = _a.translate;
            var isVertical = _this.props.isVertical;
            var childrenLength = _this.validChildren.length;
            if (touching || childrenLength <= 1)
                return;
            _this.stopAutoScrollTimer();
            var origin = 0;
            if (isVertical) {
                origin = e.targetTouches[0].pageY - _this.state.translate;
            }
            else {
                origin = e.targetTouches[0].pageX - translate;
            }
            _this.setState({
                origin: origin,
                touching: true,
                originTranslate: translate,
                touchId: e.targetTouches[0].identifier,
                animating: false,
            });
        };
        _this.handleTouchMove = function (e) {
            var _a = _this.state, touching = _a.touching, touchId = _a.touchId, translate = _a.translate, origin = _a.origin;
            var isVertical = _this.props.isVertical;
            var childrenLength = _this.validChildren.length;
            if (!touching || childrenLength <= 1)
                return;
            if (e.targetTouches[0].identifier !== touchId)
                return;
            // if (e.preventDefault) {
            //   e.preventDefault();
            // }
            var diff = translate;
            if (isVertical) {
                diff = e.targetTouches[0].pageY - origin;
            }
            else {
                diff = e.targetTouches[0].pageX - origin;
            }
            _this.setState({
                translate: diff,
            });
        };
        _this.handleTouchEnd = function () {
            var _a = _this.state, touching = _a.touching, translate = _a.translate, wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, currentIndex = _a.currentIndex, originTranslate = _a.originTranslate;
            var _b = _this.props, isVertical = _b.isVertical, speed = _b.speed;
            var childrenLength = _this.validChildren.length;
            if (!touching || childrenLength <= 1)
                return;
            var max = isVertical ? wrapperHeight - containerHeight : wrapperWidth - containerWidth;
            var diffIndex = currentIndex;
            var diffTranslate = translate;
            if (translate > 0) {
                diffTranslate = 0;
            }
            else if (translate < -max) {
                diffTranslate = -max;
            }
            else {
                var absDiffTranslate = Math.abs(translate - originTranslate);
                var isNext = translate - originTranslate < 0;
                if (absDiffTranslate >= (_this.props.threshold || 50)) {
                    if (isNext) {
                        diffTranslate = originTranslate - (isVertical ? containerHeight : containerWidth);
                        diffIndex += 1;
                    }
                    else {
                        diffTranslate = originTranslate + (isVertical ? containerHeight : containerWidth);
                        diffIndex -= 1;
                    }
                }
                else {
                    diffTranslate = _this.state.originTranslate;
                }
            }
            _this.setState({
                touching: false,
                touchId: 0,
                origin: 0,
                originTranslate: 0,
                animating: true,
                currentIndex: diffIndex,
                translate: diffTranslate,
            }, function () {
                setTimeout(function () { return _this.setState({ animating: false }); }, speed);
                _this.props.afterChange && _this.props.afterChange(Math.floor(diffIndex));
                _this.startAutoScrollTimer();
            });
        };
        _this.state = {
            containerWidth: props.width,
            containerHeight: props.height,
            wrapperWidth: 0,
            wrapperHeight: 0,
            translate: 0,
            touching: false,
            animating: false,
            touchId: 0,
            origin: 0,
            originTranslate: 0,
            currentIndex: props.defaultIndex,
            isTouchCancel: false,
            isScrollEnd: false,
        };
        return _this;
    }
    Carousel.prototype.startAutoScrollTimer = function () {
        var _this = this;
        clearInterval(this.autoScrollTimer);
        this.autoScrollTimer = window.setInterval(function () {
            _this.autoMove();
        }, 3000);
    };
    Carousel.prototype.componentDidMount = function () {
        this.startAutoScrollTimer();
        var _a = this.props, isVertical = _a.isVertical, defaultIndex = _a.defaultIndex;
        var _b = this.container, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
        var childrenLength = this.validChildren.length;
        this.setState({
            wrapperWidth: isVertical ? offsetWidth * 2 : offsetWidth * 2 * childrenLength,
            wrapperHeight: isVertical ? offsetHeight * 2 * childrenLength : offsetHeight * 2,
            containerWidth: offsetWidth * 2,
            containerHeight: offsetHeight * 2,
            translate: defaultIndex <= childrenLength
                ? isVertical
                    ? offsetHeight * 2 * -defaultIndex
                    : offsetWidth * 2 * -defaultIndex
                : 0,
        });
    };
    Carousel.prototype.componentWillUnmount = function () {
        this.stopAutoScrollTimer();
    };
    Carousel.prototype.stopAutoScrollTimer = function () {
        clearInterval(this.autoScrollTimer);
    };
    Object.defineProperty(Carousel.prototype, "validChildren", {
        get: function () {
            var _this = this;
            return React.Children.map(this.props.children, function (child, index) {
                var nodeProps = {
                    index: index,
                };
                // @ts-ignore
                return React.cloneElement(React.createElement(Item, { style: {
                        display: _this.props.isVertical ? 'block' : 'inline-block',
                        width: "" + px2rem(_this.state.containerWidth),
                        height: "" + px2rem(_this.state.containerHeight),
                    } }), __assign(__assign({}, child.props), nodeProps), child);
            });
        },
        enumerable: true,
        configurable: true
    });
    Carousel.prototype.render = function () {
        var _this = this;
        var _a = this.state, wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, animating = _a.animating, translate = _a.translate, currentIndex = _a.currentIndex;
        var _b = this.props, height = _b.height, width = _b.width, speed = _b.speed, isVertical = _b.isVertical, isShowIndex = _b.isShowIndex, indexContainerTop = _b.indexContainerTop;
        return (React.createElement(Container, { style: { height: height ? "" + px2rem(height) : '100%', width: width ? "" + px2rem(width) : '100%' }, onTouchStart: this.handleTouchStart, onTouchMove: this.handleTouchMove, onTouchEnd: this.handleTouchEnd, innerRef: function (container) { return (_this.container = container); } },
            React.createElement(ItemsWrapper, { style: {
                    width: "" + px2rem(wrapperWidth),
                    height: "" + px2rem(wrapperHeight),
                    transition: animating ? "transform ." + speed / 100 + "s" : 'none',
                    transform: "translate(" + (isVertical ? 0 : "" + px2rem(translate)) + ", " + (isVertical ? "" + px2rem(translate) : 0) + ")",
                } }, this.validChildren),
            isShowIndex && this.validChildren.length > 1 && (React.createElement(IndexContainer, { top: indexContainerTop || 100 },
                currentIndex + 1,
                "/",
                this.validChildren.length))));
    };
    return Carousel;
}(Component));
export { Carousel };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
// Carousel.defaultProps = {
//   width: null,
//   height: null,
//   defaultIndex: 0,
//   isVertical: false,
//   speed: 300,
// };
//# sourceMappingURL=Carousel.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/Carousel.js
// module id = 1228
// module chunks = 0